export const iconFontAwesomeLogisticsClipboardList = (
	<i className="fa-solid fa-clipboard-list"></i>
);
